import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';
import { fetchLayout } from 'actions/layoutsActions';
import get from 'lodash/get';

export const PRODUCT_DETAIL_REQUEST = 'PRODUCT_DETAIL_REQUEST';
export const PRODUCT_DETAIL_SUCCESS = 'PRODUCT_DETAIL_SUCCESS';
export const PRODUCT_DETAIL_ERROR = 'PRODUCT_DETAIL_ERROR';
export const PRODUCT_DETAIL_CLEAR = 'PRODUCT_DETAIL_CLEAR';
export const TOGGLE_PRIMARY_IMAGE = 'TOGGLE_PRIMARY_IMAGE';
export const WIGGLE_SWATCHES = 'WIGGLE_SWATCHES';
export const ATTACH_PRODUCTS = 'ATTACH_PRODUCTS';

export function attachProductsAction(data) {
	return { type: ATTACH_PRODUCTS, data };
}

export function wiggleSwatches(data) {
	return { type: WIGGLE_SWATCHES, data };
}

export function productDetailRequestAction() {
	return { type: PRODUCT_DETAIL_REQUEST };
}

export function productDetailSuccessAction(data) {
	return { type: PRODUCT_DETAIL_SUCCESS, data };
}

export function productDetailErrorAction(error) {
	return { type: PRODUCT_DETAIL_ERROR, error };
}

export function clearProductDetailAction() {
	return { type: PRODUCT_DETAIL_CLEAR };
}

export function getRequestContext(requestParams) {
	let requestBody = {};
	if (requestParams.pincode) {
		requestBody = Object.assign({}, requestBody, {
			locationContext: {
				pincode: requestParams.pincode
			}
		});
	}

	if (requestParams.productId) {
		requestBody = Object.assign({}, requestBody, {
			requestContext: {
				productId: requestParams.productId
			}
		});
	}
	if (requestParams.itemId) {
		requestBody = Object.assign({}, requestBody, {
			requestContext: {
				itemId: requestParams.itemId
			}
		});
	}
	if (requestParams.swatchAttr) {
		requestBody['requestContext'] = Object.assign({}, requestBody['requestContext'], {
			swatchContext: {
				attributeIdsForForceSelection: Array.isArray(requestParams.swatchAttr)
					? requestParams.swatchAttr
					: [requestParams.swatchAttr]
			}
		});
	}
	if (requestParams.listingId) {
		requestBody['requestContext'] = Object.assign({}, requestBody['requestContext'], {
			listingId: requestParams.listingId
		});
	}
	return requestBody;
}

function isLayoutPresent(layout = {}, currentLayouts = {}) {
	return currentLayouts.hasOwnProperty(layout.key) && currentLayouts[layout.key].hash === layout.id;
}

function getLayoutId(layout, currentState) {
	const layoutId = {};
	let str = '';
	const currentLayouts = get(currentState, ['productPage', 'productLayout', 'value']) || {};
	if (!isLayoutPresent(layout.page, currentLayouts)) {
		layoutId[layout.page.id] = true;
		str += `${layout.page.id},`;
	}

	for (const widget in layout.widgets) {
		if (
			layout.widgets.hasOwnProperty(widget) &&
			!isLayoutPresent(layout.widgets[widget], currentLayouts) &&
			!layoutId.hasOwnProperty(layout.widgets[widget].id)
		) {
			layoutId[layout.widgets[widget].id] = true;
			str += `${layout.widgets[widget].id},`;
		}
	}
	return str.substring(0, str.length - 1);
}

export function fetchProductDetailAction(params, requestHeaders = {}) {
	return (dispatch, getState) => {
		dispatch(productDetailRequestAction());
		const currentState = getState();
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/page/dynamic/product',
				action: PRODUCT_DETAIL_REQUEST,
				headers: Object.assign({}, headers, requestHeaders),
				acceptErrors: true
			}),
			getRequestContext(params)
		)
			.then(data => {
				data['RESPONSE'].fetchId = data['REQUEST-ID'];
				const layoutId = getLayoutId(get(data, ['RESPONSE', 'layout']), currentState);
				if (layoutId) {
					return fetchLayout(layoutId, requestHeaders).then(layout => {
						if (data && data['RESPONSE']) {
							data['RESPONSE'].productPageLayout = Object.keys(layout.RESPONSE).reduce((prev, key) => {
								const splitKey = key.split(':');
								return Object.assign(prev, {
									[splitKey[0]]: {
										value: layout.RESPONSE[key].value && JSON.parse(layout.RESPONSE[key].value),
										hash: key
									}
								});
							}, get(currentState, ['productPage', 'productLayout', 'value']) || {});
						}
						return data;
					});
				}
				data['RESPONSE'].productPageLayout = Object.assign(
					{},
					get(currentState, ['productPage', 'productLayout', 'value'])
				);
				return data;
			})
			.then(
				data => {
					dispatch(productDetailSuccessAction(data['RESPONSE']));
				},
				err => {
					dispatch(productDetailErrorAction(err));
				}
			);
	};
}

export function togglePrimaryMediaAction(image = null) {
	return { type: TOGGLE_PRIMARY_IMAGE, image };
}
